import {Component} from '@angular/core';

import {ControlWidget} from '../../widget';

@Component({
  selector: 'sf-checkbox-widget',
  templateUrl: './sf-checkbox-widget.component.html'
})
export class CheckboxWidgetComponent extends ControlWidget {
}



// WEBPACK FOOTER //
// ./src/app/schema-form/components/defaultwidgets/checkbox/sf-checkbox-widget.component.ts